import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import { BrokenContainerReport } from './BrokenContainerReport';
import type {
  BrokenContainerLineData,
  BrokenContainerReportData,
} from './brokenContainerReportFormat';

interface BrokenContainerReportsCardProps {
  title: string;
  description: string;
  reports: BrokenContainerReportData[];
  linesOf?: (report: BrokenContainerReportData) => BrokenContainerLineData[];
  showOrigin?: boolean;
  onClearLine?: (line: BrokenContainerLineData) => void;
  className?: string;
}

export function BrokenContainerReportsCard({
  title,
  description,
  reports,
  linesOf,
  showOrigin,
  onClearLine,
  className,
}: BrokenContainerReportsCardProps) {
  if (reports.length === 0) return null;
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="tw:flex tw:flex-col tw:divide-y">
        {reports.map((report) => (
          <div key={report.id} className="tw:py-4 tw:first:pt-0 tw:last:pb-0">
            <BrokenContainerReport
              report={report}
              lines={linesOf?.(report)}
              showOrigin={showOrigin}
              onClearLine={onClearLine}
            />
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
